var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCandlestick = function SvgCandlestick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    style: {
      verticalAlign: "middle"
    },
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    "aria-labelledby": "title"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.5h-1v-5.3h-2V5.9h2V4.5h1v1.4h2v8.3h-2v5.3zm-1.9-6.3h3V6.9h-3v6.3zm-5.2 6.3h-1v-1.4h-2V9.8h2V4.5h1v5.3h2v8.3h-2v1.4zm-2-2.4h3v-6.3h-3v6.3z"
  })));
};
export { SvgCandlestick as ReactComponent };